import styled from 'styled-components';

export const Container = styled.div`
  padding: 0 1rem;
  p {
    margin: 1rem 0;
  }
`;
